import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  connect() {
    this.element.querySelectorAll('.sidebar-menu-link').forEach((navElement) => {
      navElement.addEventListener('click', (e) => {
        const activeElement = this.element.querySelector('.active');
        if (activeElement) {
          activeElement.classList.remove('active');
        }

        if (!e.currentTarget.dataset.disableToggle) {
          e.currentTarget.classList.add('active');
        }

        if (!e.currentTarget.dataset.bsToggle) {
          this.closeMobileMenu();
        }
      });
    });
  }

  closeMobileMenu() {
    const navbarCollapse = this.element.querySelector('#navbarSupportedContent');
    if (navbarCollapse && navbarCollapse.classList.contains('show')) {
      const toggleButton = this.element.querySelector('.sidebar-toggle');
      if (toggleButton) {
        toggleButton.click();
      }
    }
  }
}
